import { ImageVariant, LogisticFeature, ProductFull } from '../types/catalog';
import { BASE_ROUTE, LANG } from '../config';
import React from 'react';

export const isIE = () => {
    const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    const msie = ua.indexOf('MSIE '); // IE 10 or older
    const trident = ua.indexOf('Trident/'); //IE 11

    return msie > 0 || trident > 0;
};
const transparentExt = isIE() ? '.png' : '.webp';
const ext = isIE() ? '.jpg' : '.webp';
const isPng = (url: string | null | undefined) => {
    return !!(url && url.endsWith('.png'));
};
export const selectImage = (
    variants: ImageVariant[],
    maxWidth: number,
    minWidth: number,
    def?: string | null
) => {
    let bestVariant = undefined;
    const targetExt = isPng(def) ? transparentExt : ext;
    for (const variant of variants) {
        if (variant.ext === targetExt && variant.width <= maxWidth && variant.width >= minWidth) {
            if (!bestVariant || bestVariant.width < variant.width) {
                bestVariant = variant;
            }
        }
    }
    return bestVariant?.url || def || undefined;
};

export function debounce(func: Function, timeout = 300) {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            // @ts-ignore
            func.apply(this, args);
        }, timeout);
    };
}

export function getProductLink(article: string) {
    return window.location.protocol + '//' + window.location.host + BASE_ROUTE + '/article/' + article;
}

const escapeCsvString = (str: string) => str.replace(/;/g, ':');

export function generateComplectsCsv(product: ProductFull) {
    const res: string[][] = [];
    for (const c of product.complects) {
        res.push([product.article, product.name, c.article, c.name, c.quantity.toString()]);
    }
    return '\uFEFF' + res.map((row) => row.map(escapeCsvString).join(';')).join('\n');
}

export interface LangVars {
    [key: string]: {
        [key: string]: string;
    };
}

export function getLangText(name: string, vars: LangVars) {
    return vars[LANG][name] || vars['ru'][name] || '!!LANG ERROR!!';
}

export function getFileExt(path: string) {
    return path.match(/.([A-z]+)$/)?.[1] || null;
}

export const downloadFileWithName = async (
    e: React.MouseEvent<HTMLAnchorElement>,
    url: string,
    name: string | null
) => {
    if (!name) {
        return;
    }
    e.preventDefault();
    const blob = await fetch(url).then((r) => r.blob());
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = objectUrl;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(objectUrl);
};

export function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
        return '0';
    } else {
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['байт', 'Кб', 'Мб', 'Гб', 'Тб'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
}

export function getUrlExtension(name: string) {
    const match = name.match(/\.([^.]+)$|$/);
    return match ? match[1] : '';
}

export function getRightWordForWarranty (number: string, word: string) {
    if (word.toLowerCase() !== 'лет') return word.toLowerCase();

    const lastDigit = Number(number) % 10;
    const lastTwoDigits = Number(number) % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return "лет";
    } else if (lastDigit === 1) {
        return "год";
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return "года";
    } else {
        return "лет";
    }
}

export function checkFeatures(feat: LogisticFeature[]) {
    const result: { [x: string]: boolean; } = {}

    for (const key of Object.keys(feat[0].value)) {
        result[key] = false;
    }

    for (const obj of feat) {
        for (const [key, val] of Object.entries(obj.value)) {
            if (val) result[key] = true;
        }
    }

    return result
}
